<template lang="pug">
    form#e-wallet-form(v-if='payment !== null')
        .md-form-group(:class="{'invalid':errors.has('merchant_code')}")
            input.md-input(
                type='text' 
                name='merchant_code'
                v-model='payment.meta.merchant_code'
                v-validate="'required'"
                data-vv-as='Merchant code' 
                :disabled='loading'
                ref='paymentName')
            label Merchant Code
            span.form-error-msg(v-show="errors.has('merchant_code')") {{ errors.first('merchant_code') }}

        .md-form-group(:class="{'invalid':errors.has('merchant_key')}")
            input.md-input(
                type='text'
                name='merchant_key'
                v-model='payment.meta.merchant_key'
                v-validate="'required'"
                data-vv-as='Merchant key'
                :disabled='loading')
            label Merchant Key
            span.form-error-msg(v-show="errors.has('merchant_key')") {{ errors.first('merchant_key') }}

        div.md-form-group.p-t-0
            label.multiselect-label Applicable outlets
            multiselect(
            name="outlets"
            v-model="payment.outlets"
            :options="outletList"
            placeholder="Type to search"
            label="name"
            :multiple="true"
            :loading="outletList.length === 0"
            :disabled="loading"
            :clear-on-select="false"
            :close-on-select="false"
            :hide-selected="true"
            track-by="id"
            )
            span.md-input-msg Leave empty if applicable to all outlets.
</template>

<script>
import FormMixin from '../form-mixin';

export default {
    mixins: [FormMixin],

    props: {
        payment: {
            type: Object,
            required: true,
            default: () => ({
                name: 'iPay',
                type: 4,
                preset_amount: null,
                require_reference: true,
                source: this.payment.source,
                meta: {},
                outlets: [],
            }),
        },
    },

    methods: {
        mapPaymentValue() {
            let payment = _.pick(this.payment, ['id', 'meta']);
            let source = this.payment.source;
            let name = 'iPay';

            switch (source) {
                case 'ipay_234':
                    name = 'AliPay';
                    break;
                case 'ipay_336':
                    name = 'TouchNGo';
                    break;
                case 'ipay_338':
                    name = 'Unionpay';
                    break;
                case 'ipay_305':
                    name = 'WechatPay CN';
                    break;
                case 'ipay_343':
                    name = 'WechatPay MY';
                    break;
            }

            return Object.assign(payment, {
                name: name,
                type: 4,
                preset_amount: null,
                require_reference: true,
                source: this.payment.source,
                outlets: this.payment.outlets.map(obj => obj.id),
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/custom/e-wallet-form.vue